import Styled from "styled-components";
import { maxQuery } from "../../../helpers";

export default Styled.div`
div.input--group {
    display: flex;
    max-width: 70%;
    ${maxQuery("lg")} {
        width: 95%;
        max-width: 500px;
    }
    input {
        border-radius: 5px 0px 0px 5px;
    }
    button {
background: rgb(255,123,13);
        border-radius: 0px 5px 5px 0px;
        border: none;
    }
}

input.field{
    width:150px;
    margin-right:20px;
}
div.JumbotronTitleText{
    font-family: 'Poppins';
    font-style: normal;
    position:relative;
    z-index:5;
    font-weight: 600;
    font-size: 26.8116px;
    line-height: 160%;
    color: rgba(255, 255, 255, 0.85);
    display:flex;
    align-items:center;
    @media only screen and (max-width: 900px) {
        font-size:15px;
            }
}
div.JumbotronTitleText2{
    font-family: 'Poppins';
    font-style: normal;
    position:relative;
    z-index:5;
    font-weight: 600;
    font-size: 26.8116px;
    line-height: 160%;
    color: rgba(255, 255, 255, 0.85);
    display:flex;
    align-items:center;
    @media only screen and (max-width: 900px) {
        font-size:15px;
            }
}
div.MarkerComponent{
    margin-top:90px;  
}

div.markerImage{
    display:flex;
    height:90px;
}
div.markContent{
    display:flex;
}
div.markText{
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 11.2995px;
    line-height: 21px;
    text-align:start;
    letter-spacing: -0.217793px;
    color: rgba(255, 255, 255, 0.6);
    width:180px;
}
div.JumbotronTitleAmount{
    font-family: 'Poppins';
    font-style: normal;
    position:relative;
    z-index:5;
    font-weight: 700;
    font-size: 24.1305px;
    line-height: 160%;
    color: rgba(255, 255, 255, 0.85);
    @media only screen and (max-width: 900px) {
        font-size:15px;
        padding-right:30px;
            }
}
div.curve {
    box-sizing: border-box;
    position: absolute;
    width: 396.81px;
    height: 57.2px;
    left: 113px;
    top: 875px;
}
div.JumbotronTitle{
    font-family: Poppins;
    font-style: SemiBold;
    font-size: 30px;
    line-height: 48px;
    line-height: 160%;
    margin-bottom:32px;
    width:100%;
    display:flex;
    padding-left:20px;
    color:rgba(255, 255, 255, 0.85);
    justify-content:space-between;
    align-items:center;
}
div.JumbotronTitleContainer{
    margin-top:99px;
    position:relative;
}

div.backgroundImage{
    width:50vw; height:100%;
    margin-top:-300px;
     margin-right:-620pc;
}
div.JumbotronBox{
    max-width:1201px;
    border: 1px Solid rgba(255, 255, 255, 0.2);
    max-height:258px;
    border-radious:12px;
    padding:30px;
}
div.JumbotronBoxContainer{
    margin-bottom:20px;
    display:flex;
}

div.JumbotronBoxImageTitle{
    font-family: poppins;
    font-style: regular;
    font-size: 16px;
    line-height: 26px;
    line-height: 160%;
    color:#ffffff;
   flex:1;
}
div.JumbotronBoxImageetails{
    font-family: Poppins;
    font-style: Regular;
    Font-size: 16px;
    line-height: 26px;
}
div.JumbotronBoxImage{
    display:flex;
    flex-direction:column;
    margin-left:10px;
    flex:1;
}
img {
    margin:0px;
    height:60px;
}
`;
